import React from "react";
import MasterLayout from "../masterLayout/MasterLayout";

import AddSupplierLayer from "../components/AddSupplierLayer";

export const AddSupplierPage = () => {
  return (
    <MasterLayout>
      <AddSupplierLayer/>
    </MasterLayout>
  );
};
